<template>
  <div class="paymentReceipt">
    <div class="paymentReceipt-table">
      <div class="paymentReceipt-table-option paymentReceipt-table-title">
        <div class="paymentReceipt-table-option-left ">
          凭证图片
        </div>
        <div class="paymentReceipt-table-option-right">
          金额（可编辑）
        </div>
      </div>
      <div
        class="paymentReceipt-table-box"
        v-for="file in fileList"
        :key="file.file_id"
      >
        <div class="paymentReceipt-table-option">
          <div class="paymentReceipt-table-option-left">
            <el-image
              style="width: 30px; height: 30px"
              :src="file.file_url"
              :preview-src-list="[file.file_url]"
            >
            </el-image>
            <span>
              {{ file.name }}
            </span>
            <van-icon
              name="clear"
              size="20"
              @click="onFileRemove(file)"
            />
          </div>
          <div class="paymentReceipt-table-option-right">
            <van-field
              v-model="file.ocrAmount"
              type="number"
              label=""
              size="small"
              :error-message="file.needModifyAmount ? '识别失败，请检查图片' : ''"
              @change="change"
            />
          </div>
        </div>
        <div
          class="paymentReceipt-table-option"
          v-if="file.needCompleteTxId"
        >

          <div class="paymentReceipt-table-option-1">
            <van-field
              v-model="file.tradeNo"
              type="number"
              label=""
              size="small"
              maxlength="35"
              show-word-limit
              error-message="交易识别失败，请手动补全/修改"
              @change="change"
            />
          </div>
        </div>
      </div>

    </div>
    <el-upload
      action=""
      class="booking-home-upload"
      :auto-upload="false"
      :show-file-list="false"
      :http-request="() => {}"
      :on-change="onFileChanged"
      :on-remove="onFileRemove"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :limit="50"
      accept="image/jpeg,image/jpg,image/png"
      multiple
    >
      <el-button
        size="small"
        type="primary"
      ><i class="el-icon-upload el-icon--left"></i>上传付款凭证</el-button>
      <div
        slot="tip"
        class="el-upload__tip"
      >支持扩展名：.png.jpg.jpeg</div>
    </el-upload>
    <van-popup
      v-model="dupPrompt"
      style="width: 80%;"
    >
      <div class="dupPrompt">
        <h3>
          请确认你的付款凭证
        </h3>
        <div class="dupPrompt-content">
          {{ errMsg }}
          <p>
            <span
              v-for="(i,index) in fileList"
              :key="index"
            >{{i.message}}</span>，
          </p>
          请更换凭证。
        </div>
        <el-button
          type="danger"
          round
          @click="dupPrompt = false"
        >确认</el-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import mixins from "./mixins";
import systemService from "@/apis/system/index.js";
import bookingService from "@/apis/booking";
import { Message } from "element-ui";

export default {
  name: "paymentReceipt",
  mixins: [mixins],
  props: {
    payMethod: {
      type: String,
      default: "duigong", // duigong: 对公转账   weixin: 微信转账
    },
    // 金额提示
    showAmountTip: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fileList: [],
      number: "",
      dupPrompt: false,
      errMsg: "",
    };
  },
  methods: {
    reset() {
      this.fileList = [];
      this.change();
    },
    checkOcrTradeNo(file) {
      const params = {
        file_id: file.file_id,
      };

      bookingService.checkOcrTradeNo(params).then((res) => {
        if (res.Status == -1 && (res.Code == 10010 || res.Code == 10020)) {
          if (res.Code == 10020) {
            this.errMsg = "检测到该付款凭证的【可用额度】为0，";
          } else if (res.Code == 10010) {
            this.errMsg = `检测到该付款凭证的【交易单号】已存在：`;
          }
          this.dupPrompt = true;
          file.message = res.Message;
        } else {
          file.message = undefined;
        }
        console.log(res);
        file.ocrAmount = res.ocrAmount || 0;
        file.amountOcr = res.ocrAmount || 0;
        file.tradeNo = res.tradeNo || "";
        file.payType = res.payType;
        file.receiveAccount = res.receiveAccount;
        if (res.Code == 20010) {
          file.needCompleteTxId = true;
        }
        if (!file.ocrAmount && this.showAmountTip) {
          file.needModifyAmount = true;
        }
        this.change();

        this.$forceUpdate();
      });
    },
    onFileChanged(file, fileList) {
      if (!this.beforeUpload(file)) return;
      this.$nextTick(() => {
        file.status = "uploading";
      });
      this.fileList = fileList;

      this.systemServiceUpload(file, fileList);
    },
    systemServiceUpload(file) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      const formData = new FormData();
      formData.append("file", file.raw);
      const query = {
        // file_type: "finance_returned_money",
        file_type: "work",
        file_name: file.name,
        file_ext: file.name.split(".").pop(),
        file_size: file.size,
      };

      const onUploadProgress = (progressEvent) => {
        const percentage =
          (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
        file.percentage = percentage;
        this.$forceUpdate();
      };

      systemService.upload(formData, query, onUploadProgress).then((res) => {
        file.file_id = res.file_id;
        file.file_url = res.url;
        file.status = "success";
        if (this.payMethod === "weixin") {
          this.checkOcrTradeNo(file);
        }
        this.$forceUpdate();

        this.change();
      });
    },
    beforeUpload(file) {
      console.log(file);
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        Message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        Message.error("上传图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    handleExceed(files, fileList) {
      Message.warning(
        `当前限制选择 50 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    onFileRemove(file) {
      this.fileList = this.fileList.filter(
        (item) => item.file_id !== file.file_id
      );
      this.change();
    },
    change() {
      this.fileList.forEach((item) => {
        item.trade_no_input = item.tradeNo;
        item.pay_amount_input = item.ocrAmount;
        item.pay_amount_ocr = item.amountOcr;
        item.pay_amount = item.ocrAmount;
      });
      this.fileList = [...this.fileList];
      this.$forceUpdate();

      this.answerChange(this.fileList);
    },
  },
};
</script>

<style lang="scss" scoped>
.paymentReceipt-table {
  .paymentReceipt-table-option {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .paymentReceipt-table-option-left {
      display: flex;
      align-items: center;
      font-size: 12px;
      span {
        margin: 0 3px;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .paymentReceipt-table-option-right {
      display: flex;
      align-items: center;
      width: 150px;
      flex-shrink: 0;
      padding-left: 10px;
    }
    .paymentReceipt-table-option-1 {
      flex: 1;
    }
  }
  .paymentReceipt-table-title {
    .paymentReceipt-table-option-left,
    .paymentReceipt-table-option-right {
      font-size: 14px;
    }
  }
  .paymentReceipt-table-box {
    border-bottom: 1px solid #e0e0e0;
  }
  .van-cell {
    padding: 0;
    border: none;
  }
}
.dupPrompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  .dupPrompt-content {
    text-align: center;
    margin: 20px 0;
    font-size: 12px;
    p {
      color: #f56c6c;
      margin: 0;
    }
  }
  .el-button {
    width: 200px;
  }
}
.booking-home-upload {
  margin-top: 10px;
}
</style>
<style lang="scss">
.paymentReceipt-table {
  .van-field__body {
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 5px 10px;
  }
  .van-field__error-message {
    color: red;
  }
}
.el-image-viewer__wrapper {
  z-index: 3000 !important;
}
</style>
